var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-cell",attrs:{"href":_vm.linkCellProps.href,"target":_vm.linkCellProps.target}},[_vm._v(" "+_vm._s(_vm.linkCellProps.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }